import BaseQuestionLink from './baseQuestionLink'
import QuestionLink from './questionLink'

export { QuestionLink, BaseQuestionLink }
